import { render, staticRenderFns } from "./HomeStaff.vue?vue&type=template&id=6496fc38&"
import script from "./HomeStaff.vue?vue&type=script&lang=js&"
export * from "./HomeStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports